// extracted by mini-css-extract-plugin
export var borderRadius = "_b4-4";
export var large = "_b4-3";
export var logoContainer = "_b4-0";
export var nameLogo = "_b4-2";
export var small = "_b4-1";